define([
    'text!product-detail/component/feature-list.html',
    'product-detail/mixin/product',
    'product-detail/component/feature-item',
    'lodash',

    'css!product-detail/component/feature-list.css'
], function(
    tpl,
    ProductMixin,
    FeatureItem,
    _
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        components: {
            FeatureItem: FeatureItem
        },
        computed: {
            featureData: function(){
                return this.selectedSkuExtra.featureData || {};
            },
            mainImage: function(){
                return this.featureData.mainImage || '';
            },
            featureList: function(){
                return this.featureData.list || [];
            },
            detailImages: function(){
                return this.featureData.detailImages || [];
            },
            visibleFeatureList: function(){
                return _.filter(this.featureList, function(o){
                    return !!o.isShow;
                });
            }
        },
        methods: {
            getFeatureIndex: function(index){
                var len = this.visibleFeatureList.length;
                if (len < 2) return '';
                return (index+1)+'/'+len;
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/feature-list.js
// module id = 115
// module chunks = 0